import {
  getNewBookings,
  getRequestedBookings,
  getContainerPendingBookings,
  getCompletedBookings,
  getPriorBookings,
  getCancelledPendingBookings,
  getCancelledConfirmedBookings,
  getMultipleBookings,
  searchBookings,
} from '../../../services/requests/bookings/bookings-requests';
import { DataSource } from '../../UI/view/data-source';

// Administration roles: Bookings Readonly = 33, Bookings Edit = 34, Bookings Admin = 35 (1 = Application Admin).
export const bookingsPermissions = {
  read: [1, 33, 34, 35],
  write: [1, 34, 35],
  admin: [1, 35],
};

// Page-level data source for the Bookings landing view (editMode false, never fetched).
export const bookingsDataSource = {
  name: 'bookings',
  request: getNewBookings,
  pk: 'bookingId',
} as DataSource;

const listDS = (name: string, request: (params?: any) => Promise<any>, pk = 'bookingId') => ({
  name,
  request,
  serverSideEvents: false,
  pk,
} as DataSource);

export const newBookingsDS = listDS('newBookings', getNewBookings);
export const requestedBookingsDS = listDS('requestedBookings', getRequestedBookings);
export const containerPendingBookingsDS = listDS('containerPendingBookings', getContainerPendingBookings);
export const completedBookingsDS = listDS('completedBookings', getCompletedBookings);
export const priorBookingsDS = listDS('priorBookings', getPriorBookings);
export const cancelledPendingBookingsDS = listDS('cancelledPendingBookings', getCancelledPendingBookings);
export const cancelledConfirmedBookingsDS = listDS('cancelledConfirmedBookings', getCancelledConfirmedBookings);
export const searchBookingsDS = listDS('searchBookings', searchBookings);
export const multipleBookingsDS = listDS('multipleBookings', getMultipleBookings, 'bookingNumberList');
